<div class="qr-container">
	<img class="spinner" [ngStyle]="{ padding: size != 0 ? (size - 44) / 2 + 'px' : '78px' }" src="./assets/spinner.gif" />
	<img class="qrcode" [src]="qrUrl" (click)="onQrClick(workTaskId, workTaskName)" />
</div>
